import React from "react";

const SingleLink = ({ title }) => {
    return (
        <li>
            <a href="#">{title}</a>
        </li>
    );
};

export default SingleLink;
